import CheckIn from "components/CustomerAccount/CheckIn";
import React, { Component } from "react";
import {
  format,
  lastDayOfMonth,
  lastDayOfWeek,
  lastDayOfYear,
  subDays,
} from "date-fns";
import { Alert, Snackbar } from "@mui/material";
import { CheckIncustomerApi } from "stores/CheckIn/CheckInCustomerApi";

function debounce(func, delay) {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

export default class CheckinContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "1",
      open: false,
      drawerOpen: false,
      page: 0,
      limit: 100,
      formData: {
        from_date: "",
        to_date: "",
        chargingStations: "",
        manufacturers: "",
        models: "",
        connector: "",
        inputsearch: "",
      },
      modalMessage: {
        open: false,
        message: "",
      },
      checkInDetailsStatus: "",
      formError: {
        id: false,
        name: false,
        mobile: false,
        created_at: false,
        filter_date: false,
        email: false,
      },
      ErrorMsg: "",
      datePickerOpen: false,
      sorting:'',
    };
    this.debouncedSearch = debounce(this.performSearch.bind(this), 500);

   
  }

  performSearch(searchQuery) {
    if (searchQuery) {
      this.props.CheckIncustomerAction({
        search: searchQuery,
        limit: this.state.limit,
      });
      return;
    } else this.props.CheckIncustomerAction({ limit: this.state.limit });
  }

  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };
  handleSnackbarClose = () => {
    this.setState({
      modalMessage: {
        open: false,
      },
    });
  };

  searchhandleChange = (name, value) => {
    const query = value;
    this.setState({inputsearch: query });
    this.debouncedSearch(query);
  };

  handleTabChange = (e, newValue) => {
    this.setState({ value: newValue });
  };

  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };

  toggleDrawer = (open) => {
    this.setState({ drawerOpen: open });
  };
  async componentDidMount() {
    this.handleFilterApiData();
    //  this.props.getVehicleModelData();
  }
  handleChangeSorting = async (event) => {
    const value = event.target.value;
    this.setState({ sorting: value });
    if (value == "All") {
      this.props.CheckIncustomerAction(  {
        chargingStation: this.state.formData.chargingStations,
        model: this.state.formData.models,
        connector: this.state.formData.connector,
        manufacturer: this.state.formData.manufacturers,
        startDate:this.state.formData.to_date,
        endDate:this.state.formData.from_date,
        filter:'',
        page:this.state.page,
        limit:this.state.limit
      });
    } else {
    try {
      await this.props.CheckIncustomerAction(
        {
          chargingStation: this.state.formData.chargingStations,
          model: this.state.formData.models,
          connector: this.state.formData.connector,
          manufacturer: this.state.formData.manufacturers,
          startDate:this.state.formData.to_date,
          endDate:this.state.formData.from_date,
          filter:value,
          page:this.state.page,
          limit:this.state.limit
        }
      );
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    }}
  };

  handleFilterApiData =async ()=> {
    this.props.CheckIncustomerAction(
      {
        chargingStation: this.state.formData.chargingStations,
        model: this.state.formData.models,
        connector: this.state.formData.connector,
        manufacturer: this.state.formData.manufacturers,
        startDate:this.state.formData.to_date,
        endDate:this.state.formData.from_date,
      
        page:this.state.page,
        limit:this.state.limit
      }
    );


  }
  handleReset = async () =>{
    await this.props.CheckIncustomerAction({
      limit: this.state.limit,
      page: this.state.page,
      search_term:this.state.searchkeyword
    });
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }

  handleChange = (name, value) => {
    let { formData } = this.state;
    let from_date = "";
    let to_date = format(new Date(), "yyyy-MM-dd");

    if (name === "Current Month") {
      this.setState({ formData });
    }

    if (name === "day") {
      from_date = format(new Date(), "yyyy-MM-dd");
    }
    if (name === "week") {
      const today = new Date();
      today.setDate(today.getDate() - today.getDay());
      const lastDayOfWeekVar = format(lastDayOfWeek(new Date()), "yyyy-MM-dd");
      from_date = subDays(new Date(lastDayOfWeekVar), 12);
      to_date = subDays(new Date(lastDayOfWeekVar), 6);
    }
    if (name === "month") {
      const today = new Date();
      today.setDate(1);
      today.setMonth(today.getMonth() - 1);

      const firstDateOfMonth = format(today, "yyyy-MM-01");
      const lastDateOfMonth = format(lastDayOfMonth(today), "yyyy-MM-dd");
      from_date = firstDateOfMonth;
      to_date = lastDateOfMonth;
    }
    if (name === "year") {
      const today = new Date();
      today.setDate(1);
      today.setFullYear(today.getFullYear() - 1);
      const firstDateOfYear = format(today, "yyyy-01-01");
      const lastDayOfYearzz = format(lastDayOfYear(today), "yyyy-MM-dd");
      from_date = firstDateOfYear;
      to_date = lastDayOfYearzz;
    }
    if (name === "custom") {
      from_date = this.state.formData.from_date;
      to_date = this.state.formData.to_date;
    }
    if (name === "from_date") {
      from_date = format(new Date(value), "yyyy-MM-dd");
      to_date = this.state.formData.to_date;
    }
    if (name === "to_date") {
      from_date = this.state.formData.from_date;
      to_date = format(new Date(value), "yyyy-MM-dd");
    } else {
      formData[name] = value;
      this.setState({ formData });
    }

    if (name !== "from_date" && name !== "to_date") {
      setTimeout(() => {
        this.handleFilterApiData();
      }, 500);
    }

    this.setState({
      formData: {
        ...this.state.formData,
        from_date: from_date,
        to_date: to_date,
      },
    });
  };

  onPageChange = (page, rowsPerPage) => {
    this.setState({
      page: page,
      limit: rowsPerPage,
    });
    this.props.CheckIncustomerAction({
      search:this.state.inputsearch,
      limit: rowsPerPage,
      page: page,

    });
  };

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }

  handlecheckinsubmit = async (data) => {
    try {
      const res = await CheckIncustomerApi.AddCheckinCostomerApi(data);

      if (res?.status === 1) {
        this.setState({
          modalMessage: {
            open: true,
            message: res?.message,
          },
        });
        this.setState({
          checkInDetailsStatus: res.status,
        });

        this.setState({ drawerOpen: false });

        this.handleFilterApiData();
      } else {
        console.error(
          "Form submission failed:",
          res?.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error during form submission:", error);
    }
  };

  saveManufacturerId = (id) => {
    this.setState({ manufacturers: id });

    this.props.getVehicleModelData(id);
  };
  render() {
    const checinCustome = this.props.CheckIncustomerList.visitDetails;
    const dropdownData = this.props.CheckIncustomerList?.dropdownData;
    return (
      <div>
        <CheckIn
          totalCount={this.props.CheckIncustomerList?.totalItems}
          handleTabChange={this.handleTabChange}
          value={this.state.value}
          checinCustome={checinCustome}
          saveManufacturerId={this.saveManufacturerId}
          toggleDrawer={this.toggleDrawer}
          drawerOpen={this.state.drawerOpen}
          onDatePickerSub={this.onDatePickerSub}
          props={this.props}
          isLoading={this.props.isLoading}
          isError={this.state.ErrorMsg}
          onChange={this.handleChange}
          datePickerOpen={this.state.datePickerOpen}
          from_date={this.state.formData.from_date}
          to_date={this.state.formData.to_date}
          fromat_date_from={this.state.formData.fromat_date_from}
          fromat_date_to={this.state.formData.fromat_date_to}
          formData={this.state.formData}
          dropdownData={dropdownData}
          onclick={this.handleDatePickerOpen}
          open={this.state.datePickerOpen}
          onClose={this.handleDatePickerClose}
          handlecheckinsubmit={this.handlecheckinsubmit}
          getmodeldate={this.props.getModeldropdowndata.result}
          totalItems={this.props.CheckIncustomerList?.totalItems}
          onPageChange={this.onPageChange}
          page={this.state.page}
          limit={this.state.limit}
          checkInDetailsStatus={this.state.checkInDetailsStatus}
          searchhandleChange={this.searchhandleChange}
          handleReset={this.handleReset}
          sorting={this.state.sorting}
          handleChangeSorting={this.handleChangeSorting}
      
        />

        <Snackbar
          open={this.state.modalMessage.open}
          autoHideDuration={3000}
          onClose={this.handleSnackbarClose}
          message={this.state.modalMessage.message}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity="success">{this.state.modalMessage.message}</Alert>
        </Snackbar>
      </div>
    );
  }
}
